import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import CorporateAproveDecline from "./CorporateAproveDecline";

const CorporateRefeeModal = ({ corporateDetails }) => {
  const tagData2 = [
    {
      title: "Email Address",
      discription: corporateDetails?.refereeInformation?.email,
    },
    {
      title: "Full Name",
      discription: corporateDetails?.refereeInformation?.fullName,
    },
    {
      title: "Job Title",
      discription: corporateDetails?.refereeInformation?.jobTitle,
    },
    {
      title: "Membership Id",
      discription: corporateDetails?.refereeInformation?.membershipId,
    },
    {
      title: "Phone Number",
      discription: corporateDetails?.refereeInformation?.phoneNumber,
    },
    {
      title: "qualification",
      discription: corporateDetails?.refereeInformation?.qualification,
    },
  ];

  return (
    <>
      <Box h={"60vh"} overflow={"scroll"}>
        {tagData2?.map((data, index) => (
          <Flex
            px={[1, null, null]}
            my={5}
            fontSize={"18px"}
            fontWeight={"500"}
            fontFamily={"roboto"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            mb={4}
            key={index}
            gap={[6, 3, 3]}
          >
            <Text
              width={"35%"}
              color={"#121212"}
              fontWeight={"400"}
              lineHeight={"18.9px"}
            >
              {data.title}
            </Text>
            <Text width={"65%"} color={"#7A7A7A"} lineHeight={"21.09px"}>
              {data.discription}
            </Text>
          </Flex>
        ))}
        {!corporateDetails?.memberCategory && (
          <CorporateAproveDecline corporateDetails={corporateDetails} />
        )}
      </Box>
    </>
  );
};

export default CorporateRefeeModal;
